import { tipoAtividadeByIdRecord } from 'view/atividade-coletiva/model-atividadeColetiva'

import {
  HistoricoAtividadeColetivaDwSaudeModel,
  HistoricoAtividadeColetivaSaudeModel,
} from './model-historicoAtividadeColetiva'

export const convertHistoricoAtividadeColetivaDwSaudeToHistoricoAtividadeColetivaSaude = (
  historicoAtividadeColetivaDwSaude: HistoricoAtividadeColetivaDwSaudeModel
): HistoricoAtividadeColetivaSaudeModel => {
  return {
    id: historicoAtividadeColetivaDwSaude.id,
    atividadeSaudePse: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.stPseSaude,
    atividadeEducacaoPse: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.stPseEducacao,
    temasSaude: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.temasSaude,
    tipoAtividade:
      historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoTipoAtividade?.id &&
      tipoAtividadeByIdRecord[historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoTipoAtividade.id],
    publicoAlvo: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.publicoAlvo,
    praticasSaude: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.praticasSaude,
    procedimento: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoProcedimento && {
      id: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoProcedimento.id,
      descricao: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoProcedimento.descricaoProcedimento,
      codigo: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoProcedimento.codigoProcedimento,
    },
    participante: {
      id: historicoAtividadeColetivaDwSaude.id,
      atividadeColetivaId: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.id,
      peso: historicoAtividadeColetivaDwSaude.nuPesoParticipante,
      altura: historicoAtividadeColetivaDwSaude.nuAlturaParticipante,
      avaliacaoAlterada: historicoAtividadeColetivaDwSaude.stAvaliacaoAlterada,
      pnctAbandonouGrupo: historicoAtividadeColetivaDwSaude.stPnctAbandonouGrupo,
      pnctCessouHabitoFumar: historicoAtividadeColetivaDwSaude.stPnctCessouHabitoFumar,
    },
    lotacaoResponsavel: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoProfissional && {
      id: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoProfissional.id,
      ativo: undefined,
      profissional: {
        id: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoProfissional.id,
        nome: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoProfissional.nome,
        cpf: undefined,
      },
      cbo: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoCbo && {
        id: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoCbo.id,
        nome: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoCbo.nome,
        cbo2002: undefined,
      },
      unidadeSaude: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoUnidadeSaude && {
        id: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoUnidadeSaude.id,
        nome: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoUnidadeSaude.nome,
        cnes: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoUnidadeSaude.cnes,
      },
      equipe: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoEquipe && {
        id: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoEquipe.id,
        nome: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoEquipe.nome,
        ine: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoEquipe.ine,
      },
    },
    inepLocalAtividade: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoInep && {
      id: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoInep.id,
      nomeEstabelecimento: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoInep.noEstabelecimento,
      dsInep: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoInep.nuIdentificador,
    },
    unidadeSaudeLocalAtividade: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoUnddSadeAcdmSade && {
      id: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoUnddSadeAcdmSade.id,
      nome: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoUnddSadeAcdmSade.nome,
      cnes: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.dimensaoUnddSadeAcdmSade.cnes,
    },
    outraLocalidade: historicoAtividadeColetivaDwSaude.fatoAtividadeColetiva.descricaoOutraLocalidade,
  }
}
